import Vue from 'vue'

import Qs from 'qs'

class Sites {
  async index({params}) {
    return await Vue.axios
      .get('app/sites', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/sites', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/sites/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/sites/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/sites/' + id)
  }
}

const sites = new Sites()

export default sites
